<template>
<div class="row">
  <div class="col-md-6">
    <div class="form-group has-feedback">

      <div class="col-sm-7 col-xs-6">
        <Input v-if="ip" ref="ip" label="Статический&nbsp;IP" v-model="ip" :size=8 :labelSize=4 :disabled="!$store.getters.permGet('billing.client.ip.any')" :mask=maskaOpt
          :apiDomain=domain apiTopic=client :apiPath="state.entity" name="ip" />
        <Input v-else ref="newIp" label="Статический&nbsp;IP" :size=8 :labelSize=4 :disabled="!$store.getters.permGet('billing.client.ip.any')" 
          :mask=maskaOpt name="ip" :save=allocateNewIp />
      </div>

      <span class="input-addon">
        <div class="btn-group allocate-ip" v-show="!ip" >
          <button class="btn btn-default auto-allocate-ip" type="button" @click="allocateIp('*')">
            <span title="Выделить IP" class="glyphicon glyphicon-plus" style="cursor:pointer"></span>
          </button>

          <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span class="caret"></span>
            <span class="sr-only">Из пула</span>
          </button>
          <ul class="dropdown-menu">
              <li class="allocate-from-pool" v-for="p in $store.getters.preload(domain, 'static-pools')">
                <a v-if="p.has_free" href="#">
                  <span :class="{'text-success': !p.gray}" @click="allocateIp('*', p.id)">{{p.ip}}</span>
                </a>
              </li>
          </ul>
        </div>

        <span title="Очистить IP" class="glyphicon glyphicon-remove" style="cursor: pointer" v-show="ip" @click="freeIp()" />
      </span>
    </div>
  </div>
  
  <div class="col-md-6" id="static-tp-id" v-show="ip">
      <Select ref="tp" label="Тариф" v-model="tp" :size=5 :labelSize=2 :options="$store.getters.preload(domain, 'tplan?static-ip')" 
        textName="display_name" valueName="entity"
        :apiDomain=domain apiTopic=client :apiPath="state.entity" name="tp_id" />
  </div>

</div>
</template>

<script>
import darsan from "darsan"
import { vMaska } from "maska/vue"
import {domainByUid} from "sysconf.js"
import Select from "common/visual/cooper/Select.vue"
import Input from "common/visual/cooper/Input.vue"

export default {
  name: "IpChooser",
  
  components: {Select, Input},

  directives: { maska: vMaska },
  
  props: {
    state: Object,
  },
  
  data()
  {
    return {
      ip: "",
      tp: null,
      domain: "",

      maskaOpt: {
        mask: "#00.#00.#00.#00",
        tokens: {
          0: { pattern: /[0-9]/, optional: true }
        },
        
      },
    }  
  },
  
  created()
  {
    this.ensure(["static-pools", "tplan?static-ip"])
  },

  methods: {
    async loadData()
    {
      this.clearError()
      try 
      {
        const res = await darsan.getm(this.domain, "client", this.state.entity)
        this.ip = res.extra.ip
        this.tp = String(res.tp_id)
      }
      catch(xhr) 
      {
        if (xhr.status == 404) 
        {
          this.ip = ""
        }
        else
        {
          darsan.err(xhr)
        }
      }
    },
    
    async allocateIp(ip, pool=null)
    {
      this.clearError()
      const params = {ip}
      if (pool) params.static_pool = pool
      await this.promiseAllocateIp(params)
    },

    promiseAllocateIp(params)
    {
      return darsan.post(this.domain, "client", this.state.entity, params)
      .then( res =>
      {
        this.ip = res.extra.ip
        this.tp = String(res.tp_id)
      })
    },
    
    async freeIp()
    {
      this.clearError()
      await darsan.delete(this.domain, "client", this.state.entity)
      this.ip = ""
    },
    
    clearError()
    {
      if (!this.$refs.ip) return
      this.$refs.ip.setError("")
      this.$refs.tp.setError("")
    },
  
    allocateNewIp()
    {
      return this.promiseAllocateIp({ ip: $("input[name=ip]").val() })
    },
    
  },
  
  watch: {
    state:
    {
      deep: true,
      immediate: true,
      async handler(val)
      {
        this.domain = domainByUid(this.state.uid)
        this.loadData()
      },
    },
  },
  
}
</script>

<style scoped>
</style>
